import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-nginx',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>NGINX icon</title><path d="M12 0L1.605 6v12L12 24l10.395-6V6L12 0zm6 16.59c0 .705-.646 1.29-1.529 1.29-.631 0-1.351-.255-1.801-.81l-6-7.141v6.66c0 .721-.57 1.29-1.274 1.29H7.32c-.721 0-1.29-.6-1.29-1.29V7.41c0-.705.63-1.29 1.5-1.29.646 0 1.38.255 1.83.81l5.97 7.141V7.41c0-.721.6-1.29 1.29-1.29h.075c.72 0 1.29.6 1.29 1.29v9.18H18z"/></svg>`,
    styles: []
})
export class SimpleIconsNginxComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#269539';
    @Input() className: string = 'simple-icons-nginx'
    constructor() {}
    ngOnInit(): void {}
}
